import { numify } from 'numify';
import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import { Activity } from '@/core/interfaces';
import { formatHMS, secondsToHMS } from '@/app/shared/utils';
import { CoinImage } from '@/app/shared/components';
import { Tag } from '@/app/shared/components/common';

interface SpecialActivityItemProps {
	activity: Activity;
	onClickActivity: (activity: Activity, drawerVisibility: boolean) => void;
}

export const SpecialActivityItem: React.FC<SpecialActivityItemProps> = ({
	activity,
	onClickActivity,
}: SpecialActivityItemProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Functions
	**********************/

	/*********************
	// #region Template
	**********************/
	return (
		<div
			key={activity.id}
			className={`flex flex-col rounded-2xl relative ${
				activity.buyOnlyOnce
					? activity.userInfo?.currentLevel &&
					  activity.userInfo?.currentLevel > 0
						? 'bg-category-special-gradient brightness-50'
						: 'bg-category-special-gradient'
					: 'bg-category-special-gradient'
			} p-3`}
			onClick={() => {
				if (
					activity.userInfo &&
					activity.userInfo?.timerRemainingSeconds === 0 &&
					!activity.expired
				) {
					onClickActivity(activity, true);
				}
			}}
		>
			{/* Card header */}
			<div>
				<div className="flex gap-1 absolute right-4 top-4">
					{activity.isNew && <Tag type="new" />}

					{activity.buyOnlyOnce && <Tag type="unique" />}
				</div>

				<img
					src={
						activity.image ||
						process.env.VITE_PLACEHOLDER_ACTIVITY_IMAGE
					}
					alt={activity.thumbnail.title}
					className="rounded-2xl shadow-xl"
				/>
			</div>

			{/* Card body */}
			<div className="mt-2">
				<p className="flexc items-center text-sm text-center font-bold min-h-[32px] px-2 leading-tight">
					{activity.thumbnail.title}
				</p>

				{/*  */}
				<div className="flex justify-evenly mt-2">
					{activity.buyOnlyOnce || activity.expired ? (
						activity.userInfo?.currentLevel &&
						activity.userInfo.currentLevel > 0 ? (
							<Tag type="owned" />
						) : null
					) : (
						<p className="text-xs font-bold">
							Lvl {activity.userInfo?.currentLevel || 0}
						</p>
					)}

					{activity.userInfo?.currentLevel == 0 && (
						<div className="flex justify-center items-center">
							<CoinImage
								alt={activity.thumbnail.title}
								width={'15px'}
							/>

							{activity.userInfo &&
							activity.userInfo.nextLevelPrice ? (
								<p className="text-xs font-bold">
									{numify(activity.userInfo.nextLevelPrice)}
								</p>
							) : (
								<p className="text-xs font-bold">
									{activity.initialPrice > 0
										? numify(activity.initialPrice)
										: t('free')}
								</p>
							)}
						</div>
					)}
				</div>
			</div>

			{/* {activity.buyOnlyOnce &&
			activity.userInfo?.currentLevel &&
			activity.userInfo?.currentLevel > 0 ? null : (
				<div className="flex items-center justify-evenly">

				</div>
			)} */}

			{activity.userInfo &&
				activity.userInfo?.currentLevel > 0 &&
				activity.userInfo?.accumulatedRewards > 0 && (
					<div className="flex self-center items-center mt-1">
						<img
							className="drop-shadow-lg"
							src={
								activity.expired &&
								activity.userInfo?.currentLevel &&
								activity.userInfo?.currentLevel > 0
									? process.env.VITE_COIN_IMAGE_DISABLED
									: process.env.VITE_COIN_IMAGE
							}
							alt={activity.thumbnail.title}
							width={'20px'}
						/>

						<p className="text-xs font-bold">
							+
							{activity.userInfo?.accumulatedRewards
								? numify(activity.userInfo.accumulatedRewards)
								: 0}
							/{t('general.hour')}
						</p>
					</div>
				)}

			{/* {activity.buyOnlyOnce &&
			activity.userInfo &&
			activity.userInfo.currentLevel > 0 ? (
				<div className="text-[8px] bg-green-600 white px-2 rounded-lg py-[2px] inline">
					{t('alreadyOwned')}
				</div>
			) : null} */}

			{activity.userInfo &&
				activity.userInfo.timerRemainingSeconds > 0 && (
					<div
						className={`rounded-xl p-6 flex flex-col justify-center bg-customer-950/85 absolute top-0 left-0 w-full h-full items-center`}
					>
						<p className="text-xs text-yellow-600">
							{t('categories.cooldown')}
						</p>
						<p className="text-xs text-yellow-600">
							{formatHMS(
								secondsToHMS(
									activity.userInfo.timerRemainingSeconds
								)
							)}
							⏳
						</p>
					</div>
				)}
		</div>
	);
};
